import { Injectable } from '@angular/core';
import { SportMapItem } from '../definitions/sport-map-item';
import { InjectableMapDataStateService } from '@ui/shared/domain-map';
import type { SportMapFilterKey } from '../types/sport-map-filter';

@Injectable({ providedIn: 'root' })
export class SportMapMapDataService extends InjectableMapDataStateService<SportMapItem, SportMapFilterKey> {
}
